import BasicEditor from './BasicEditor.react';
import PropTypes from 'prop-types';

interface EditorWithSubmitProps {
 submit?: (...args: unknown[]) => unknown;
}

export class EditorWithSubmit extends BasicEditor<EditorWithSubmitProps> {
    static propTypes = {
        submit: PropTypes.func,
    };

    submitForm(data) {
        return this.props.submit(data);
    }
}
